module.exports = __webpack_public_path__ + "static/media/dungeon_floor_w2.6ab162fa.png";